import { IPartnerWebpage } from "../../lib/models"

export const partnerWebpageOverride: {
  [licenseName: string]: Partial<IPartnerWebpage>
} = {
  "Wellesley Strategic": {
    cobrandedImageUrl:
      "https://coverdash.s3.amazonaws.com/images/cobrand-logos-coverdash.jpg",
  },
}
